@let component = customComponent();
@if (component) {
  <ng-container *ngComponentOutlet="component"/>
} @else {
  <div class="wysiwig" [innerHTML]="markdown()"></div>
}
<homey-lotteries-and-footer/>
